var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 189,
    viewBox: "0 0 141 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 189,
    rx: 11,
    fill: "#F4F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.2174 114.5H47.7826C44.1087 114.5 41 111.346 41 107.618V82.3823C41 78.6544 44.1087 75.5 47.7826 75.5H86.2174C89.8913 75.5 93 78.6544 93 82.3823V107.618C93 111.346 89.8913 114.5 86.2174 114.5Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2812 101.309L53.1508 89.2645C55.6943 86.6836 59.9334 86.6836 62.7595 89.2645L76.3247 103.029",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6523 99.0146L79.1524 92.419C80.5654 90.9852 82.8263 90.9852 84.2393 92.419L92.7176 101.022",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6503 87.2575C74.2111 87.2575 75.4764 85.9736 75.4764 84.3899C75.4764 82.8061 74.2111 81.5222 72.6503 81.5222C71.0895 81.5222 69.8242 82.8061 69.8242 84.3899C69.8242 85.9736 71.0895 87.2575 72.6503 87.2575Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarVertical);
export default __webpack_public_path__ + "static/media/avatar_vertical.9865e97fbe04d720fc2be636d0f3f290.svg";
export { ForwardRef as ReactComponent };